import { Box, Typography, Stack, Link, Divider, } from '@mui/material';
import CustomLink from '../custom-link';
import CustomContainer from '../custom-container';
import { LogoIcon, } from '../custom-svg';

const Footer = () => {
    const styles = {
        linkStyles: {
            color: 'grey.600',
            fontSize: 13,
            '&:hover': {
                color: 'secondary.main',
            },
        },
        dividerStyles: {
            alignSelf: 'center',
            display: ['none', 'block'],
            height: '14px',
        },
    };

    return (
        <Box
            component='footer'
            sx={{
                borderTop: 1,
                borderTopColor: 'borderColor.main',
                bgcolor: 'primary.main',
                py: 3,
            }}>
            <CustomContainer>
                <Stack
                    direction={{
                        xs: 'column',
                        lg: 'row',
                    }}
                    alignItems={{
                        xs: 'stretch',
                        sm: 'center',
                    }}>
                    <Stack
                        direction='row'
                        alignItems='center'
                        spacing={1}
                        sx={{
                            mr: {
                                lg: 'auto',
                            },
                            mb: {
                                xs: 3,
                                lg: 0,
                            },
                        }}>
                        <LogoIcon sx={{color: 'text.primary'}} />
                        <Typography
                            sx={{
                                color: 'text.primary',
                                fontSize: 12,
                                letterSpacing: 3,
                            }}>CARDS - английский с удовольствием</Typography>
                    </Stack>
                    <Stack
                        direction={{
                            xs: 'column',
                            sm: 'row',
                        }}
                        spacing={{
                            xs: 1,
                            sm: 1.5,
                            md: 2,
                        }}>
                        <CustomLink
                            to='/terms'
                            sx={{...styles.linkStyles}}>
                            Условия и положения
                        </CustomLink>
                        <Divider
                            orientation='vertical'
                            variant='middle'
                            sx={{...styles.dividerStyles}}/>
                        <CustomLink
                            to='/confidentiality'
                            sx={{...styles.linkStyles}}>
                            Политика конфиденциальности
                        </CustomLink>
                        <Divider
                            orientation='vertical'
                            variant='middle'
                            sx={{...styles.dividerStyles}}/>
                        <Typography
                            sx={{
                                color: 'text.primary',
                                fontSize: 13,
                            }}>
                            Разработано <Link
                            href='https://gasmg.ru'
                            target='_blank'
                            sx={{
                                color: 'text.primary',
                                textDecoration: 'underline',
                                '&:hover': {
                                    color: 'secondary.main',
                                },
                            }}>gasmg</Link>
                        </Typography>
                    </Stack>
                </Stack>
            </CustomContainer>
        </Box>);
};

export default Footer;